import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'
import { ref } from 'vue'
import type { DropdownInstance } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const router = useRouter()
const dropdown1 = ref<DropdownInstance>()
const OnMenu = () => {
  if (!dropdown1.value) return
  dropdown1.value.handleOpen()
}
const logout = () => {
  localStorage.removeItem('token')
  router.push({ name: 'login' })
}

return (_ctx: any,_cache: any) => {
  const _component_ElAvatar = _resolveComponent("ElAvatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_ElCol = _resolveComponent("ElCol")!
  const _component_ElRow = _resolveComponent("ElRow")!

  return (_openBlock(), _createBlock(_component_ElRow, { style: {"margin-top":"20px","padding":"0px 40px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_ElCol, {
        span: 12,
        offset: 12,
        style: {"text-align":"right"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown, {
            ref_key: "dropdown1",
            ref: dropdown1,
            trigger: "click",
            style: {"margin-right":"30px"}
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { onClick: logout }, {
                    default: _withCtx(() => [
                      _createTextVNode("Logout")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ElAvatar, {
                size: 50,
                src: _ctx.circleUrl,
                onClick: OnMenu
              }, null, 8, ["src"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})